import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "23"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "#FFF",
      d: "M19.9 5.3c1.7 1.7 2.6 3.9 2.6 6.3s-.9 4.6-2.6 6.3m-2.7-10c1 1 1.5 2.3 1.5 3.7s-.6 2.7-1.5 3.7M6.7 6.9H.5v9.3h6.2l6.2 5.7V1.2z"
    }, null, -1)
  ]))]))
}
export default { render: render }